import "../sass/app.scss";

import Vue from "../node_modules/vue/dist/vue.common";
import assessment_data from "./assessment-data.js";
import Modal from './lib/modal.js';
import Dropdown from "./lib/Dropdown";
import Expandset from "./lib/expandset";
import VueRecaptcha from 'vue-recaptcha';

const EARLY_GATING_FIELDS = [
    'c_name',
    'c_email',
    'c_title',
    'c_institution',
    'c_state',
    'c_phone'
];

let OnlineAssessment = function (elId) {
    if (!document.getElementById(elId)) {
        return null;
    }

    return new Vue({
        el: `#${elId}`,
        components: {
            'vue-recaptcha': VueRecaptcha
        },
        data: {
            el: document.getElementById(elId),
            is_mounted: false,
            is_loading: false,
            is_fading: false,
            tools_edit_pointer: -1,
            tool_errors: {
                purposes: false,
                grades: false,
                tool: false
            },
            grades_error: false,
            goal_error: false,
            consultation_errors: {
                c_city: false,
                c_email: false,
                c_phone: false,
                c_institution: false,
                c_name: false,
                c_reason: false,
                c_state: false,
                c_title: false
            },
            share_errors: {
                c_institution: false,
                message: false,
                recipients: [
                    {
                        name: false,
                        email: false
                    },
                    {
                        name: false,
                        email: false
                    },
                    {
                        name: false,
                        email: false
                    },
                    {
                        name: false,
                        email: false
                    }
                ],
                recaptcha: false
            },
            assessment_data: {
                id: null,
                learning_objective: null,
                grade_levels_interest: [],
                rows: [],
                c_name: '',
                c_email: '',
                c_phone: '',
                c_title: '',
                c_institution: '',
                c_city: '',
                c_state: '',
                c_reason: ''
            },
            results: {},
            results_page: 1,
            results_grid_mode: 'selections',
            selections_data: { /* fills the modals on results grid */
                selections: {},
                grade: '',
                label: ''
            },
            recommendations: [],
            goals_list: assessment_data.goals_list,
            grades_list: assessment_data.grades_list,
            tools_list: assessment_data.tools_list,
            purposes_list: assessment_data.purposes_list,
            hollistic_frameworks: assessment_data.hollistic_frameworks,
            hollistic_descriptions: assessment_data.hollistic_descriptions,
            is_editable: true,
            consultation_saving: false,
            consultation_confirmed: false,
            mode: '',
            share: {
                message: '',
                message: '',
                recaptcha: null,
                recipients: [
                    {
                        name: '',
                        email: ''
                    }
                ]
            },
            is_sharing: false,
            is_shared: false
        },
        computed: {
            user_tool_selections: function () {
                let tool_selection = [];
                this.assessment_data.rows.forEach(tool => {

                    let grade_levels_current = [];
                    Object.keys(this.grades_list).forEach((key) => {
                        if (tool && tool.grade_levels_current.indexOf(key) >= 0) {
                            grade_levels_current.push(key);
                        }
                    });

                    let purpose = [];
                    Object.keys(this.purposes_list).forEach((key) => {
                        if (tool && tool.purpose.indexOf(key) >= 0) {
                            purpose.push(key);
                        }
                    });

                    let assessment_tools = tool.assessment_tools;

                    tool_selection.push({
                        grade_levels_current: grade_levels_current.sort(function (a, b) {
                            return a === 'K' ? -1 : a - b;
                        }).reverse(),
                        purpose,
                        text__other_tool: tool.text__other_tool,
                        assessment_tools
                    });
                });

                return tool_selection;
            },

            grades_selected_sorted: function () {
                return this.assessment_data.grade_levels_interest.slice().sort(function (a, b) {
                    if(a === 'K') {
                        a = '0';
                    }

                    if(b === 'K') {
                        b = '0';
                    }

                    return a - b;
                }).reverse();
            },

            grades_sorted: function () {
                let grades = Object.keys(this.grades_list).slice().sort(function (a, b) {
                    if(a === 'K') {
                        a = '0';
                    }

                    if(b === 'K') {
                        b = '0';
                    }

                    return a - b;
                }).reverse();

                return grades;
            },

            can_submit_assessment: function() {
                let tool_errors
                if(this.assessment_data.rows[this.tools_edit_pointer]) {
                    tool_errors = this.assessment_data.rows[this.tools_edit_pointer].assessment_tools &&
                        this.assessment_data.rows[this.tools_edit_pointer].purpose.length &&
                        this.assessment_data.rows[this.tools_edit_pointer].grade_levels_current.length;
                }
                else {
                    tool_errors = true;
                }

                let grades_error = this.assessment_data.grade_levels_interest.length ? false : true;
                let goal_error = this.goals_list[this.assessment_data.learning_objective] ? false : true;

                return tool_errors && !grades_error && !goal_error;
            },

            prev_button_label: function() {
                if(this.results_page === 1) {
                    return false;
                }

                let lower = this.grades_selected_sorted[(this.results_page - 2) * 4];
                let upper = this.grades_selected_sorted[((this.results_page - 1) * 4) - 1];

                return `Grades ${lower} - ${upper}`;
            },

            next_button_label: function() {
                if(this.results_page > 1 && (this.grades_selected_sorted.length - (this.results_page * 4)) <= 0) {
                    return false;
                }

                let lower = (this.results_page * 4);
                let upper = (this.results_page * 4) + 3;

                if(!this.grades_selected_sorted[upper]) {
                    upper = lower + (this.grades_selected_sorted.length % 4) - 1;
                }

                lower = this.grades_selected_sorted[lower];
                upper = this.grades_selected_sorted[upper];

                if(upper && upper !== lower) {
                    return `Grades ${lower} - ${upper}`;
                }
                else if(lower) {
                    return `Grade ${lower}`;
                }

                return false;
            }
        },
        mounted: function () {
            let urlParams = new URLSearchParams(window.location.search);
            let id = urlParams.get('id');

            this.is_mounted = true;

            if(id) {
                id = atob(id);
                this.loadAssessment(id).then((response) => {
                    if(this.isUserIntakeValid()) {
                        this.changeMode('results');
                        this.is_editable = false;
                    }
                    else {
                        this.changeMode('user intake');
                        this.initAssessment()
                        this.addUserIntakeTool();
                    }
                });
            }
            else{
                this.changeMode('user intake');
                this.addUserIntakeTool();
            }

            /* init consultation modal */
            let modal_el = document.querySelector(`[data-modal="consultation-modal"]`);
            Modal.createModal(modal_el, {
                toggle_selector: `[data-close-modal="consultation-modal"]`,
            });

            /* init share modal */
            let share_modal_el = document.querySelector(`[data-modal="share-modal"]`);
            
            Modal.createModal(share_modal_el, {
                toggle_selector: `[data-toggle-modal="share-modal"]`,
            });

            /* event listener for print button */
            document.body.addEventListener('click', (e) => {
                if(e && e.target && e.target.dataset.print) {
                    window.print();
                }
            });
        },
        methods: {
            initAssessment() {
                this.assessment_data = {
                    id: null,
                    learning_objective: null,
                    grade_levels_interest: [],
                    rows: [],
                }

                this.tool_errors = {
                    purposes: false,
                    grades: false,
                    tool: false
                };
                this.tools_edit_pointer = -1;

                this.grades_error = false;
                this.goal_error = false;
            },

            startNewAssessment: function(e) {
                e && e.preventDefault();

                this.is_fading = true;
                window.setTimeout(() => {
                    this.initAssessment();
                    this.addUserIntakeTool();
                    this.changeMode('user intake');
                    this.is_editable = true;
                }, 500);
            },

            changeMode: function (new_mode, e) {
                e && e.preventDefault();

                this.is_fading = true;

                if (new_mode === "results") {
                    this.results_grid_mode = 'selections';
                    this.calculateResults();
                    this.calculateRecommendations();
                }

                window.setTimeout(() => {
                    window.scrollTo(0, 0);
                    this.mode = new_mode;
                    this.is_fading = false;
                    this.initializeNewDropdowns();
                    this.initializeExpandsets();
                }, 500);
            },

            initSelectionsPopup: function (e) {
                if (e && e.target && e.target.dataset.toggleModal && e.target.dataset.toggleModal === 'selections-modal') {
                    e.preventDefault();

                    let selections = [];
                    let creative_selections = [];
                    let other_selections = [];

                    let modal_el = document.querySelector(`[data-modal="${e.target.dataset.toggleModal}"]`);
                    let modal = Modal.createModal(modal_el, {
                        toggle_selector: `[data-close-modal="${e.target.dataset.toggleModal}"]`,
                        onOpen: e.target.dataset.toggleModal === 'share-modal' ? () => {
                            this.is_shared = false;
                        } : null
                    });
                    modal.toggleModal();

                    this.selections_data.selections = e.target.dataset.selections ? e.target.dataset.selections.split(',') : [];
                    this.selections_data.other_names = {};
                    this.selections_data.is_creative = {};
                    this.selections_data.class_override = {};

                    this.selections_data.grade = e.target.dataset.grade;
                    this.selections_data.label = e.target.dataset.label;
                    this.selections_data.class = e.target.dataset.class;
                    this.selections_data.description  = e.target.dataset.description;

                    if(e.target.dataset.recommendation) {
                        this.selections_data.class = 'recommendation';
                    }

                    this.selections_data.selections.forEach((selection ,index) => {
                        if(selection.indexOf(':::') >= 0) {
                            let split_selection = selection.split(':::');
                            this.selections_data.selections[index] = split_selection[0];
                            this.selections_data.other_names[split_selection[0]] = split_selection[1];

                            other_selections.push(this.selections_data.selections[index]);
                        }
                        else  if(selection.indexOf('$$$') >= 0) {
                            let split_selection = selection.split('$$$');
                            this.selections_data.selections[index] = split_selection[0];
                            this.selections_data.is_creative[split_selection[0]] = true;
                            this.selections_data.class = 'creative';
                            this.selections_data.class_override[split_selection[0]] = 'creative';

                            creative_selections.push(this.selections_data.selections[index]);
                        }
                        else if(selections.indexOf(this.selections_data.selections[index]) < 0) {
                            selections.push(this.selections_data.selections[index]);
                        }
                    });

                    this.selections_data.selections = selections.concat(creative_selections, other_selections);
                }
            },

            addUserIntakeTool: function (e) {
                e && e.preventDefault();

                if(this.assessment_data.rows.length && this.tools_edit_pointer >= 0) {
                    if(!this.isToolSelectionValid(this.tools_edit_pointer)) {
                        return;
                    }
                }

                this.assessment_data.rows.push({
                    grade_levels_current: [],
                    purpose: [],
                    text__other_tool: '',
                    assessment_tools: null
                });

                this.tools_edit_pointer = this.assessment_data.rows.length - 1
                this.initializeNewDropdowns();
            },

            initializeNewDropdowns: function () {
                window.setTimeout(() => {
                    let Dropdowns = document.querySelectorAll(
                        "[data-control='dropdown']"
                    );

                    Dropdowns.forEach(dropdown => {
                        new Dropdown(dropdown);
                    });
                }, 0);
            },

            initializeExpandsets: function() {
                window.setTimeout(() => {
                    let expandsets = document.querySelectorAll('[data-expandset]');
                    expandsets.forEach((expandset) => {
                        new Expandset(expandset);
                    });
                }, 0);
            },

            editUserIntakeTool: function(e, index) {
                e && e.preventDefault();

                if(index === this.tools_edit_pointer) {
                    return;
                }

                let last_toolset = this.assessment_data.rows[this.assessment_data.rows.length - 1];

                if(!last_toolset.assessment_tools && !last_toolset.purpose.length && !last_toolset.grade_levels_current.length) {
                    this.assessment_data.rows.pop();
                }

                if(this.assessment_data.rows.length && this.tools_edit_pointer >= 0) {
                    if(!this.isToolSelectionValid()) {
                        return;
                    }
                    else {
                        this.tools_edit_pointer = index;
                        this.isToolSelectionValid()
                    }
                }


                this.initializeNewDropdowns();
            },

            removeUserIntakeTool: function (e, index) {
                e && e.preventDefault();

                this.assessment_data.rows.splice(index, 1);

                if (
                    !this.isToolSelectionValid(
                        this.assessment_data.rows.length - 1
                    )
                ) {
                    this.tools_edit_pointer =
                        this.assessment_data.rows.length - 1;
                }

                if (this.assessment_data.rows.length <= 0) {
                    this.addUserIntakeTool();
                }
            },

            isToolSelectionValid: function () {
                if(!this.assessment_data.rows[this.tools_edit_pointer]) {
                    return true;
                }

                this.tool_errors = {
                    tool: this.assessment_data.rows[this.tools_edit_pointer].assessment_tools ? false : true,
                    purposes: this.assessment_data.rows[this.tools_edit_pointer].purpose.length ? false : true,
                    grades: this.assessment_data.rows[this.tools_edit_pointer].grade_levels_current.length ? false : true
                }

                return (
                    !this.tool_errors.tool &&
                    !this.tool_errors.purposes &&
                    !this.tool_errors.grades
                );
            },

            isUserIntakeValid: function () {
                let rows_valid = this.isToolSelectionValid();
                this.grades_error = this.assessment_data.grade_levels_interest.length ? false : true;
                this.goal_error = this.goals_list[this.assessment_data.learning_objective] ? false : true;

                return (
                    rows_valid &&
                    !this.grades_error &&
                    !this.goal_error
                );
            },

            submitUserIntake: function (e) {
                e && e.preventDefault();

                if (this.isUserIntakeValid()) {
                    /* if assessment has already been saved skip modal */
                    if(this.assessment_data.id) {
                        this.saveAssessment().then(() => {
                            this.changeMode("results");
                        });

                        return;
                    }

                    /* check url param to skip gateway */
                    if (typeof URLSearchParams !== 'undefined') {
                        let params = new URLSearchParams(window.location.search);
                        if(params.get('ref') === 'nogateway') {
                            this.changeMode("results");
                            return;
                        }
                    }

                    let modal = Modal.getModalById('consultation-modal');
                    modal.showModal();
                }
            },

            submitConsultation: function(e) {
                e && e.preventDefault();

               

                if(!this.validateConsultation()) {
                    return false;
                }

                this.consultation_saving = true;
                this.saveAssessment(true).then(() => {
                    if(this.mode === 'results') {
                        this.consultation_confirmed = true;
                    }
                    else {
                        let modal = Modal.getModalById('consultation-modal');
                        modal.hideModal();
                        this.changeMode("results");
                    }
                }).finally(() => {
                    this.consultation_saving = false;
                });
            },

            validateConsultation: function() {
                let valid = true;

                Object.keys(this.consultation_errors).forEach((key) => {
                    /* skip results only fields on the early gating */
                    if(this.mode !== 'results' && EARLY_GATING_FIELDS.indexOf(key) < 0) {
                        return;
                    }

                    if(!this.assessment_data[key].length) {
                        this.consultation_errors[key] = true;
                        valid = false;
                    }
                    else {
                        this.consultation_errors[key] = false;
                    }
                });

                return valid;
            },

            calculateResults: function () {
                let results = {};
                results.purposes = [];
                results.frameworks = [];

                // initialize results purposes arrays
                this.assessment_data.rows.forEach((tool) => {
                    tool.purpose.forEach((purpose) => {
                        let grades = {};
                        this.assessment_data.grade_levels_interest.forEach((grade) => {
                            grades[grade] = [];
                        });

                        if (results.purposes.findIndex((el) => {return el.index === purpose}) < 0) {
                            results.purposes.push({
                                index: purpose,
                                grades: grades,
                                recommendations: {}
                            });
                        }
                    });
                });

                //fill results purposes arrays
                results.purposes.forEach((purpose) => {
                    this.assessment_data.rows.forEach((tool_row) => {
                        this.assessment_data.grade_levels_interest.forEach((grade) => {
                            if(tool_row.grade_levels_current.indexOf(grade) < 0 || tool_row.purpose.indexOf(purpose.index) < 0) {
                                return;
                            }

                            if (this.assessment_data.grade_levels_interest.indexOf(grade) >= 0) {
                                let tool = tool_row.assessment_tools;
                                let tool_data = this.tools_list[tool];
                                if(purpose.index === 'other') {
                                    if(tool_data.is_other && tool_data.grades.indexOf(grade) >= 0 && tool_data.purposes.indexOf(purpose.index) >= 0 && purpose.grades[grade].indexOf(tool) < 0) {
                                        purpose.grades[grade].push(`${tool}:::${tool_row.text__other_tool}`);
                                    }
                                    else {
                                        purpose.grades[grade].push(`${tool}$$$not_applicable`);
                                    }
                                }
                                else if(tool_data.is_other && tool_row.purpose.indexOf(purpose.index) >= 0) {
                                    purpose.grades[grade].push(`${tool}:::${tool_row.text__other_tool}`);
                                }
                                else if (tool_data && tool_data.grades.indexOf(grade) >= 0 && tool_data.purposes.indexOf(purpose.index) >= 0 && purpose.grades[grade].indexOf(tool) < 0) {
                                    purpose.grades[grade].push(tool);
                                }
                                else {
                                    purpose.grades[grade].push(`${tool}$$$not_applicable`);
                                }
                                
                            }
                        });
                    });
                });

                /* fill purpose recommendations */
                results.purposes.forEach((purpose) => {
                    Object.keys(purpose.grades).forEach((grade_key) => {
                        let grade = purpose.grades[grade_key];
                        let recommendations_list = [];
                        
                        let has_appropriate_solution = false;

                        if(grade.length) {
                            grade.forEach((item) => {
                                if(item.indexOf('$$$not_applicable') < 0) {
                                    has_appropriate_solution = true;
                                }
                            });
                        }

                        if(!has_appropriate_solution) {
                            this.purposes_list[purpose.index].recommendations.forEach((tool) => {
                                if(this.tools_list[tool].grades.indexOf(grade_key) >= 0 && !this.tools_list[tool].third_party) {
                                    if(!this.tools_list[tool].deprecated) {
                                        recommendations_list.push(tool);
                                    }
                                }
                            });
                        }

                        purpose.recommendations[grade_key] = recommendations_list
                    });
                });

                // initialize results frameworks arrays
                this.hollistic_frameworks.forEach((framework, index) => {
                    let grades = {};
                    this.assessment_data.grade_levels_interest.forEach((grade) => {
                        grades[grade] = [];
                    });

                    results.frameworks.push({
                        index: index,
                        grades: grades,
                        recommendations: {}
                    });
                });

                //fill results frameworks arrays
                results.frameworks.forEach((framework) => {
                    this.assessment_data.rows.forEach((tool_row) => {
                        this.assessment_data.grade_levels_interest.forEach((grade) => {
                            if (this.assessment_data.grade_levels_interest.indexOf(grade) >= 0) {
                                let tool = tool_row.assessment_tools
                                let tool_data = this.tools_list[tool];
                                if (tool_data && tool_data.grades.indexOf(grade) >= 0 && tool_data.frameworks.indexOf(framework.index) >= 0 &&
                                tool_row.grade_levels_current.indexOf(grade) >= 0 && framework.grades[grade].indexOf(tool) < 0) {
                                    framework.grades[grade].push(tool);
                                }
                            }
                        });
                    });
                });

                /* fill frameworks recommendations */
                results.frameworks.forEach((framework, index) => {
                    Object.keys(framework.grades).forEach((grade_key) => {
                        let grade = framework.grades[grade_key];
                        let recommendations_list = [];
                        if(grade.length <= 0) {
                            Object.keys(this.tools_list).forEach((tool) => {
                                if(this.tools_list[tool].grades.indexOf(grade_key) >= 0 && this.tools_list[tool].frameworks.indexOf(index) >= 0 && !this.tools_list[tool].third_party) {
                                    if(!this.tools_list[tool].deprecated) {
                                        recommendations_list.push(tool);
                                    }
                                }
                            });
                        }
                        framework.recommendations[grade_key] = recommendations_list
                    });
                });

                this.results = results;
                this.results_page = 1;
            },

            changeResultsPage: function(e, page_delta) {
                e && e.preventDefault();
                let new_page = this.results_page + page_delta;
                if(new_page > 0 && ((new_page * 4) - this.grades_selected_sorted.length) < 4) {
                    this.results_page = new_page;
                }
            },

            displayCell: function(index, length) {
                if(index < 4 * this.results_page && index >= 4 * (this.results_page - 1)) {
                    return 'cell-show';
                }
                return 'cell-hide';
            },

            calculateRecommendations: function () {
                let selected_tools = [];
                let recommendations = [];

                recommendations = recommendations.concat(this.goals_list[this.assessment_data.learning_objective].recommendations);

                this.assessment_data.rows.forEach((tool) => {
                    tool.purpose.forEach((purpose) => {
                        recommendations = recommendations.concat(this.purposes_list[purpose].recommendations);
                    });

                    if (selected_tools.indexOf(tool.assessment_tools) < 0) {
                        if(Array.isArray(tool.assessment_tools) && tool.assessment_tools.length) {
                            selected_tools.push(tool.assessment_tools[0]);
                        }
                        else {
                            selected_tools.push(tool.assessment_tools);
                        }
                    }
                });

                this.assessment_data.grade_levels_interest.forEach((grade) => {
                    recommendations = recommendations.concat(this.grades_list[grade].recommendations);
                });

                recommendations = recommendations.filter((el, index, array) => {
                    if(selected_tools.indexOf(el) >= 0) {
                        return false;
                    }

                    if(!this.assessment_data.grade_levels_interest.some(r=> this.tools_list[el]?.grades.includes(r))) {
                        return false;
                    }

                    return array.indexOf(el) === index;
                });

                this.recommendations = [];
                recommendations.forEach((tool) => {
                    if(!this.tools_list[tool].third_party) {
                        this.recommendations.push(tool);
                    }
                });
            },

            saveAssessment(is_consultation = false) {
                let data = Object.assign({}, this.assessment_data);
                data.assessment_data = {
                    learning_objective: this.assessment_data.learning_objective,
                    grade_levels_interest: this.assessment_data.grade_levels_interest,
                    rows: this.assessment_data.rows
                }

                data.action = 'save';
                data.is_consultation = is_consultation;

                data.assessment_data.rows.forEach((row) => {
                    if(!Array.isArray(row.assessment_tools)) {
                        row.assessment_tools =  [row.assessment_tools];
                    }
                });

                if(!data.id) {
                    delete data.id;
                }

                delete data.learning_objective;
                delete data.grade_levels_interest;
                delete data.rows;

                return fetch(`/api/v1/save-assessment`, {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    return response.json();
                })
                .then(response => {
                    this.assessment_data.id = response.assessment;
                    if(window.fbq) {
                        window.fbq('trackCustom', 'completeAssessment', {assessmentID:  window.btoa(this.assessment_data.id)});
                    }
                });
            },

            loadAssessment(id) {
                let url = `/api/v1/load-assessment/${id}`;
                return fetch(url, {
                    method: 'GET'
                })
                .then(response => response.json())
                .then(response => {
                    if(response) {
                        if(response.assessment) {
                            this.assessment_data = Object.assign({}, response.assessment.assessment_data, response.assessment);
                            delete this.assessment_data.assessment_data;
                            delete this.assessment_data.parsed;
                            delete this.assessment_data.sent_to_salesforce;
                            delete this.assessment_data.created_at;
                            delete this.assessment_data.updated_at;

                            this.assessment_data.rows.forEach((row) => {
                                if(typeof row.grade_levels_current === 'number') {
                                    row.grade_levels_current = [row.grade_levels_current];
                                }
                                if(Array.isArray(row.assessment_tools)) {
                                    row.assessment_tools =  row.assessment_tools[0] || null;
                                }
                            });

                        }
                        else {
                            this.assessment_data = response;
                        }

                        return this.assessment_data;
                    }
                });
            },

            addShareRecipient: function(e) {
                e && e.preventDefault();

                if(this.share.recipients.length < 4) {
                    this.share.recipients.push({
                        name: '',
                        email: ''
                    });
                }
            },

            removeShareRecipient: function(e) {
                e && e.preventDefault();

                if(this.share.recipients.length > 1) {
                    this.share.recipients.pop();
                }
            },

            submitShare: function (e) {
                e && e.preventDefault();

                if(!this.validateShare()) {
                    return false;
                }

                this.is_sharing = true;

                if(this.share.recaptcha) {
                    this.sendShare();
                }
                else {
                    this.$refs.recaptcha.execute();
                }
            },

            validateShare: function() {
                let valid = true;

                if(!this.assessment_data.c_institution) {
                    this.share_errors.c_institution = true;
                    valid = false;
                }
                else {
                    this.share_errors.c_institution = false;
                }

                if(!this.share.message.length) {
                    this.share_errors.message = true;
                    valid = false;
                }
                else {
                    this.share_errors.message = false;
                }

                if(!this.share.message.length) {
                    this.share_errors.message = true;
                    valid = false;
                }
                else {
                    this.share_errors.message = false;
                }

                this.share_errors.recipients.forEach((item, index) => {
                    if(this.share.recipients[index]) {
                        if(!this.share.recipients[index].name.length) {
                            item.name = true;
                            valid = false;
                        }
                        else {
                            item.name = false;
                        }

                        if(!this.share.recipients[index].email.length) {
                            item.email = true;
                            valid = false;
                        }
                        else {
                            item.email = false;
                        }
                    }
                });

                return valid;
            },

            sendShare: function() {
                this.is_sharing = true;

                let data = {
                    id: this.assessment_data.id,
                    c_institution: this.assessment_data.c_institution,
                    share_message: this.share.message,
                    share_recaptcha: this.share.recaptcha,
                    share_recipients: this.share.recipients
                }

                return fetch('/api/v1/share-assessment', {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(APIResponseData => {
                    this.is_sharing = false;

                    // If recaptcha fails validation for whatever reason - display an error message.
                    if (APIResponseData.status != 'success') {
                        this.share.recaptcha = false;
                    } else {
                        window.setTimeout((response) => {
                            this.is_shared = true;
                        }, 300);
                    }
                });
            },

            onCaptchaVerified: function(token) {
                if(token) {
                    this.share.recaptcha = token;
                    this.sendShare();
                }
            },

            onCaptchaExpired: function() {
                this.share.recaptcha = false;
                this.$refs.recaptcha.reset();
            },

            isOtherTool: function(tool) {
                return (this.tools_list[tool] && this.tools_list[tool].is_other) || false;
            },

            selectAllGrades: function(e) {
                e && e.preventDefault();

                let available_grades = Object.keys(this.grades_list);

                if(this.assessment_data.grade_levels_interest.length === available_grades.length) {
                    this.assessment_data.grade_levels_interest = [];
                }
                else {
                    this.assessment_data.grade_levels_interest = available_grades.slice();
                }
            },

            selectAllRowGrades(e, row_index = 0) {
                e && e.preventDefault();

                let available_grades = Object.keys(this.grades_list);

                if(this.assessment_data.rows[row_index].grade_levels_current.length === available_grades.length) {
                    this.assessment_data.rows[row_index].grade_levels_current = [];
                }
                else {
                    let grades = available_grades.slice().reverse();

                    if(grades.length && grades[0] === 'K') {
                        grades.push(grades.shift());
                    }

                    this.assessment_data.rows[row_index].grade_levels_current = grades;
                }
            },

            /* prevent overlapping act products from causing warning */
            isResultsCellWarning: function(cell) {
                let third_party_tools = [];

                cell.forEach((tool_id) => {
                    if(tool_id.indexOf(':::') >= 0) {
                        let split_selection = tool_id.split(':::');
                        tool_id = split_selection[0];
                    }

                    if(tool_id.indexOf('$$$') >= 0) {
                        let split_selection = tool_id.split('$$$');
                        tool_id = split_selection[0];
                    }

                    if(this.tools_list[tool_id].third_party || this.tools_list[tool_id].is_other) {
                        third_party_tools.push(tool_id);
                    }
                });

                if(third_party_tools.length > 1 || (third_party_tools.length && cell.length > third_party_tools.length)) {
                    return false;
                }

                return true;
            },

            getResultsCellIcon: function(cell) {
                let third_party_tools = [];
                let is_creative = false;

                cell.forEach((tool_id) => {
                    if(tool_id.indexOf(':::') >= 0) {
                        let split_selection = tool_id.split(':::');
                        tool_id = split_selection[0];
                    }

                    if(tool_id.indexOf('$$$') >= 0) {
                        let split_selection = tool_id.split('$$$');
                        tool_id = split_selection[0];
                        is_creative = true;
                    }

                    if(this.tools_list[tool_id].third_party || this.tools_list[tool_id].is_other) {
                        third_party_tools.push(tool_id);
                    }
                });

                if((third_party_tools.length > 1 || (third_party_tools.length && cell.length > third_party_tools.length) && !is_creative)) {
                    return 'icon-exclamation';
                }

                if(is_creative) {
                    return 'icon-bulb';
                }

                return 'icon-check';
            },

            changeResultsGridMode: function(e) {
                this.results_grid_mode = e.target.checked ? 'recommendations' : 'selections';
            }
        }
    });
};

let oa = new OnlineAssessment("online-assessment");
